import React from 'react';
import { Product } from '@portal/portal-core';
import { fjButtonTypes } from 'components/primitives';
import type { FjButtonType } from 'components/primitives/fj-button';
import { withTheme } from 'styled-components';
import { UserClientActions } from 'ducks/user-client';
import { selectCurrentUser, selectLicenseStatus } from 'selectors';
import theme from 'styles/theme';
import * as utils from 'utils';
import { useAppDispatch, useAppSelector } from 'store/hooks';

import BaseButton from './base-button';

const { NAMES_LICENSED_PRODUCTS } = Product;

interface BuyButtonProps {
  product: string;
  buttonType?: FjButtonType;
  buyNowUrl: string;
}

// `analyzeLicense` (cloud-core) types these fields as `any`; capture the fields we read.
interface ProductLicenseInfo {
  id: string;
  costCenterId: string;
}

const BuyButton = ({ product, buttonType, buyNowUrl }: BuyButtonProps): React.JSX.Element => {
  const chinaFlag = utils.chinaFlag();
  const text = chinaFlag ? '点击购买' : 'Buy Now';
  const currentUser = useAppSelector(selectCurrentUser);
  const licenseStatus = useAppSelector(selectLicenseStatus);
  const dispatch = useAppDispatch();

  const handleClick = (): void => {
    const buyNowChinaLink =
      'https://detail.tmall.com/item.htm?id=578858816507&ut_sk=1.X8EXMTMzdOkDANEK5NUVABnX_21380790_1647521493894.Copy.ShareGlobalNavigation_1&sourceType=item&suid=5C7F8385-8708-4624-88FE-B37915D903D9&un=80fe7286ad3dfc5f722a898ac8f12c2e&share_crt_v=1&un_site=0&spm=a2159r.13376460.0.0&tbSocialPopKey=shareItem&sp_tk=Vm93SDI1QmdoVTk=&cpp=1&shareurl=true&short_name=h.fotcxqo&bxsign=scdEoKlXtbZnSyq1NIIjWM93a5ty_225akQqCHAO2fcJnbZI4S2ZXs9TAUvvVyOHSY6PfRGAGHNLu3v-3Y5blXzTbUVaZwPXZ4smU2zK07P_W-oY6GSl8A5G2AQPxlxKcIS&tk=VowH25BghU9%E3%80%8CFlowJo&app=chrome';

    if (chinaFlag) {
      window.open(buyNowChinaLink, '_blank');
    } else if (product === NAMES_LICENSED_PRODUCTS.flowJo || NAMES_LICENSED_PRODUCTS.seqGeq) {
      const { id: userId, primaryEmail } = currentUser;
      const { id: productAccessId, costCenterId } = (licenseStatus.productLicenseInfo ||
        {}) as ProductLicenseInfo;
      const payload = UserClientActions.authcodeRedirect({
        baseUrl: buyNowUrl,
        userId,
        primaryEmail,
        product,
        productAccessId,
        costCenterId,
      });
      dispatch(payload);
    }
  };
  return (
    <BaseButton
      onClick={handleClick}
      buttonType={buttonType}
      defaultStyle={{
        color:
          buttonType === fjButtonTypes.LINK ? theme.colors.selectableLightBg : theme.colors.white,
        background: theme.colors.accentButton,
        borderColor: theme.colors.accentButton,
      }}
      hoverStyle={{
        color: theme.colors.white,
        background: theme.colors.accentButtonRollover,
        borderColor: theme.colors.accentButtonRollover,
      }}
    >
      <span>{text}</span>
    </BaseButton>
  );
};

export default withTheme(BuyButton);
